import { ActionType } from 'deox';
import { takeLatest, put } from 'redux-saga/effects';

import { API } from 'api';

import { processRequestError } from 'modules/errors';

import { createArtwork, deleteArtwork, updateArtwork } from './actions';

function* createArtworkSaga({ payload }: ActionType<typeof createArtwork.request>) {
  try {
    const { data } = yield API.createArtwork(payload.requestBody, payload.requestParams);
    yield put(createArtwork.success(data));
    payload.onSuccess();
  } catch (error) {
    yield put(processRequestError({ error, failAction: createArtwork.fail }));
  }
}

function* deleteArtworkSaga({ payload }: ActionType<typeof deleteArtwork.request>) {
  try {
    yield API.deleteArtwork(payload.requestParams);
    yield put(deleteArtwork.success(payload.requestParams));
    payload.onSuccess();
  } catch (error) {
    yield put(processRequestError({ error, failAction: deleteArtwork.fail }));
  }
}

function* updateArtworkSaga({ payload }: ActionType<typeof updateArtwork.request>) {
  try {
    const { data } = yield API.updateArtwork(payload.requestBody, payload.requestParams);
    yield put(updateArtwork.success(data));
    payload.onSuccess();
  } catch (error) {
    yield put(processRequestError({ error, failAction: updateArtwork.fail }));
  }
}

export function* watchArtwork() {
  yield takeLatest(createArtwork.request, createArtworkSaga);
  yield takeLatest(deleteArtwork.request, deleteArtworkSaga);
  yield takeLatest(updateArtwork.request, updateArtworkSaga);
}
